<template>
  <v-container v-if="!containerInitLoading && department" fluid style="height: inherit">
    <v-row align="stretch" style="height: inherit;">
      <v-col style="max-width: 400px;">
        <EntityEditCard :title="$t('servicesystem.common_objects.commonterms.details')" :item="department"
          :saveMethod="saveChanges">
          <template v-slot:content="{ item, copy, editMode, handleFocus }">
            <DepartmentEditContent :originalItem="copy" :editItem="item" :editMode="editMode"
              :handleFocus="handleFocus">
            </DepartmentEditContent>
          </template>
        </EntityEditCard>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import EntityEditCard from "@/views/layouts/EntityEditCard.vue";
import DepartmentEditContent from "@/views/admin/departments/DepartmentEditContent.vue";

export default {
  name: "ViewDepartmentInfo",
  props: {
    containerInitLoading: Boolean, //getting container data for the first time, show skeletonloader
    containerLoading: Boolean, //loading container data update, do so in the background with small indicator
    containerItem: Object, //container data
  },
  components: {
    EntityEditCard,
    DepartmentEditContent,
  },
  mixins: [clientAPI],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {
    async saveChanges(obj) {
      const dto = Object.assign({}, obj);
      await this.updateDepartment(dto)
        .then((response) => {
          this.department = response;
        })
        .catch((exception) => {
          console.error(exception);
        });
    },
  },

  computed: {
    department: {
      get() {
        return this.containerItem;
      },
      set(value) {
        this.$emit('SetContainerItem', value);
      }
    },

  },

  watch: {

  },
};
</script>


<style lang='scss'></style>